import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import Home from './pages/Home.jsx';
import Result from './pages/Result.jsx';
import Troubleshoot from './pages/Troubleshoot.jsx';
import Wiki from './pages/Wiki.jsx';
import History from './pages/History.jsx';
import Admin from './pages/Admin.jsx';
import Help from './pages/Help.jsx';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="result" element={<Result />} />
        <Route path="troubleshoot" element={<Troubleshoot />} />
        <Route path="wiki" element={<Wiki />} />
        <Route path="history" element={<History />} />
        <Route path="help" element={<Help />} />
        <Route path="admin" element={<Admin />} />
      </Route>
    </Routes>
  );
}
